/**
 * @flow
 * @relayHash 19e3182b613efbce7c307f0cd480deac
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteVendorItemPriceInput = {|
  id: string
|};
export type DeleteVendorItemPriceMutationVariables = {|
  input: DeleteVendorItemPriceInput
|};
export type DeleteVendorItemPriceMutationResponse = {|
  +deleteVendorItemPrice: {|
    +success: boolean
  |}
|};
export type DeleteVendorItemPriceMutation = {|
  variables: DeleteVendorItemPriceMutationVariables,
  response: DeleteVendorItemPriceMutationResponse,
|};
*/


/*
mutation DeleteVendorItemPriceMutation(
  $input: DeleteVendorItemPriceInput!
) {
  deleteVendorItemPrice(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteVendorItemPriceInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteVendorItemPrice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteVendorItemPricePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteVendorItemPriceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteVendorItemPriceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteVendorItemPriceMutation",
    "id": null,
    "text": "mutation DeleteVendorItemPriceMutation(\n  $input: DeleteVendorItemPriceInput!\n) {\n  deleteVendorItemPrice(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1d527befc89aeb689c86fd20886329df';
module.exports = node;
